/* Fiche produit V2 LAO Care (25/10/2026) : galerie, curseur avant / après, date de livraison estimée, mesures Google Analytics.
   Événements (paramètre « produit » = handle) : lao_fiche_vue, lao_fiche_galerie_image, lao_fiche_galerie_interaction, lao_fiche_galerie_derniere, lao_fiche_video_vue, lao_fiche_video_complete,
   lao_fiche_curseur, lao_fiche_section_vue, lao_fiche_defilement, lao_fiche_temps, lao_fiche_clic, lao_fiche_ajout_panier, lao_fiche_repli, lao_fiche_question, lao_fiche_playshorts, lao_fiche_routine, lao_fiche_avis_clic. */
(function () {
  if (window.__laoV2) return;
  window.__laoV2 = true;

  var produit = (document.querySelector('[data-lao-galerie]') || {}).dataset ? document.querySelector('[data-lao-galerie]').dataset.produit : '';
  var dejaEnvoyes = {};
  function evenement(nom, params, cle) {
    if (cle) { if (dejaEnvoyes[cle]) return; dejaEnvoyes[cle] = true; }
    var p = Object.assign({ produit: produit }, params || {});
    try { if (typeof window.gtag === 'function') window.gtag('event', nom, p); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nom }, p)); } catch (e) {}
  }

  /* Galerie glissante */
  document.querySelectorAll('[data-lao-galerie]').forEach(function (g) {
    var piste = g.querySelector('[data-lao-piste]');
    var slides = g.querySelectorAll('[data-lao-slide]');
    var miniatures = g.querySelectorAll('[data-lao-miniature]');
    if (!piste || !slides.length) return;
    var actuel = 0;
    function indexVisible() {
      var gauche = piste.getBoundingClientRect().left, meilleur = 0, ecart = Infinity;
      slides.forEach(function (s, i) { var d = Math.abs(s.getBoundingClientRect().left - gauche); if (d < ecart) { ecart = d; meilleur = i; } });
      return meilleur;
    }
    function marquer(i) { miniatures.forEach(function (m, k) { m.classList.toggle('is-active', k === i); }); }
    function maj() {
      var i = indexVisible();
      marquer(i);
      if (i !== actuel) { actuel = i; }
      evenement('lao_fiche_galerie_image', { image: i + 1 }, 'galerie-' + (i + 1));
    }
    var minuterie;
    piste.addEventListener('scroll', function () { clearTimeout(minuterie); minuterie = setTimeout(maj, 120); }, { passive: true });
    function aller(k) { var s = slides[Math.max(0, Math.min(slides.length - 1, k))]; piste.scrollTo({ left: s.offsetLeft - piste.offsetLeft, behavior: 'smooth' }); }
    var prec = g.querySelector('[data-lao-prec]'), suiv = g.querySelector('[data-lao-suiv]');
    if (prec) prec.addEventListener('click', function () { aller(indexVisible() - 1); });
    if (suiv) suiv.addEventListener('click', function () { aller(indexVisible() + 1); });
    miniatures.forEach(function (m) {
      m.addEventListener('click', function () {
        var k = Number(m.getAttribute('data-lao-miniature'));
        marquer(k); aller(k);
        evenement('lao_fiche_clic', { element: 'miniature_' + (k + 1) });
      });
    });
    evenement('lao_fiche_galerie_image', { image: 1 }, 'galerie-1');
  });

  /* Curseur avant / après (glisser au doigt ou à la souris, flèches au clavier) */
  document.querySelectorAll('[data-lao-aa]').forEach(function (aa) {
    var appui = false, range = aa.querySelector('input[type=range]');
    function poser(pct) { pct = Math.max(0, Math.min(100, pct)); aa.style.setProperty('--lao-pos', pct + '%'); if (range) range.value = Math.round(pct); }
    function depuis(e) { var r = aa.getBoundingClientRect(); poser(((e.clientX - r.left) / r.width) * 100); }
    aa.addEventListener('pointerdown', function (e) { appui = true; depuis(e); evenement('lao_fiche_curseur', {}, 'curseur'); });
    aa.addEventListener('pointermove', function (e) { if (appui) depuis(e); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (t) { aa.addEventListener(t, function () { appui = false; }); });
    if (range) range.addEventListener('input', function () { poser(Number(range.value)); evenement('lao_fiche_curseur', {}, 'curseur'); });
  });

  /* Date de livraison estimée : jour ouvré avant l'heure limite = expédiée le jour même, sinon le jour ouvré suivant */
  document.querySelectorAll('[data-lao-livraison]').forEach(function (el) {
    try {
      var heureLimite = Number(el.dataset.heure || 14), jMin = Number(el.dataset.min || 2), jMax = Number(el.dataset.max || 4);
      var feries = (el.dataset.feries || '').split(/[\s,;]+/).filter(Boolean);
      var p = {};
      new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var jour = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
      function iso(d) { return d.toISOString().slice(0, 10); }
      function ouvre(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && feries.indexOf(iso(d)) < 0; }
      function suivant(d) { var n = new Date(d.getTime()); do { n.setUTCDate(n.getUTCDate() + 1); } while (!ouvre(n)); return n; }
      function plus(d, k) { var n = d; for (var i = 0; i < k; i++) n = suivant(n); return n; }
      var envoi = ouvre(jour) && +p.hour < heureLimite ? jour : suivant(jour);
      var jours = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
      var mois = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
      function court(d) { return jours[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + mois[d.getUTCMonth()]; }
      var cible = el.querySelector('[data-lao-livraison-texte]');
      /* États-Unis et Canada (décision de Lisa du 25/10/2026) : pas de date précise, un délai large (le calcul ci-dessus vaut pour la France, la Belgique et le Luxembourg) */
      var paysVisiteur = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
      if (paysVisiteur === 'US' || paysVisiteur === 'CA') {
        var langueVisiteur = String(document.documentElement.lang || 'fr').slice(0, 2);
        var delaisUsa = { fr: 'Livraison en 5 à 10 jours ouvrés', en: 'Delivery in 5 to 10 business days', it: 'Consegna in 5-10 giorni lavorativi', es: 'Entrega en 5 a 10 días laborables', de: 'Lieferung in 5 bis 10 Werktagen' };
        if (cible) cible.textContent = delaisUsa[langueVisiteur] || delaisUsa.fr;
        return;
      }
      if (cible) cible.textContent = 'Livrée entre le ' + court(plus(envoi, jMin)) + ' et le ' + court(plus(envoi, jMax));
    } catch (e) {}
  });

  /* Sections vues (défilement) */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (!en.isIntersecting) return;
        var nom = en.target.getAttribute('data-lao-section');
        evenement('lao_fiche_section_vue', { section: nom }, 'section-' + nom);
        obs.unobserve(en.target);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-lao-section]').forEach(function (s) { obs.observe(s); });
  }

  /* Clics */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-lao-clic]');
    if (c) evenement('lao_fiche_clic', { element: c.getAttribute('data-lao-clic') });
    if (e.target.closest('[data-cart-bar-add-to-cart]')) evenement('lao_fiche_clic', { element: 'barre_fixe' });
    var principal = e.target.closest('.lao2-produit [name="add"], .lao2-produit button[type="submit"][id^="ProductSubmitButton"]');
    if (principal && !e.target.closest('cart-bar')) evenement('lao_fiche_clic', { element: 'bouton_principal' });
  }, true);

  /* Questions et replis ouverts */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    if (d.hasAttribute('data-lao-question')) evenement('lao_fiche_question', { question: d.getAttribute('data-lao-question') });
    if (d.hasAttribute('data-lao-repli')) evenement('lao_fiche_clic', { element: 'repli_' + d.getAttribute('data-lao-repli') });
  }, true);

  /* Mesures supplémentaires (25/10/2026, bilan du 1er décembre) : chaque geste a son propre événement Google Analytics */
  evenement('lao_fiche_vue', { modele: 'v2', largeur: window.innerWidth < 750 ? 'mobile' : 'ordinateur' }, 'vue');

  /* Galerie : première interaction volontaire, dernière image atteinte */
  document.querySelectorAll('[data-lao-galerie]').forEach(function (g) {
    var piste = g.querySelector('[data-lao-piste]');
    var slides = g.querySelectorAll('[data-lao-slide]');
    if (!piste || !slides.length) return;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (t) {
      piste.addEventListener(t, function () { evenement('lao_fiche_galerie_interaction', { geste: t }, 'galerie-interaction'); }, { passive: true, once: true });
    });
    g.querySelectorAll('[data-lao-prec],[data-lao-suiv],[data-lao-miniature]').forEach(function (b) {
      b.addEventListener('click', function () { evenement('lao_fiche_galerie_interaction', { geste: 'bouton' }, 'galerie-interaction'); });
    });
    piste.addEventListener('scroll', function () {
      if (piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 8) evenement('lao_fiche_galerie_derniere', { images: slides.length }, 'galerie-derniere');
    }, { passive: true });
  });

  /* Vidéo de la galerie : lancée seulement quand elle est visible (la page charge plus vite), mise en pause quand elle sort ; vue et boucle regardée jusqu'au bout */
  document.querySelectorAll('.lao2-slide video').forEach(function (v) {
    var dernier = 0;
    v.muted = true;
    v.addEventListener('timeupdate', function () {
      if (v.duration && dernier > v.duration * 0.85 && v.currentTime < 1) evenement('lao_fiche_video_complete', { duree: Math.round(v.duration) }, 'video-complete');
      dernier = v.currentTime;
    });
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) {
            var p = v.play();
            if (p && p.then) p.then(function () { evenement('lao_fiche_video_vue', {}, 'video-vue'); }).catch(function () {});
          } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0.4 });
      o.observe(v);
    } else { try { v.play(); } catch (e) {} }
  });

  /* Défilement de la page : 25, 50, 75, 90 % */
  var seuils = [25, 50, 75, 90];
  window.addEventListener('scroll', function () {
    var haut = window.pageYOffset || document.documentElement.scrollTop;
    var total = document.documentElement.scrollHeight - window.innerHeight;
    if (total <= 0) return;
    var pct = (haut / total) * 100;
    seuils.forEach(function (s) { if (pct >= s) evenement('lao_fiche_defilement', { pourcentage: s }, 'defilement-' + s); });
  }, { passive: true });

  /* Temps passé sur la page, onglet visible : 15, 30, 60, 120 secondes */
  var secondes = 0;
  setInterval(function () {
    if (document.hidden) return;
    secondes += 5;
    [15, 30, 60, 120].forEach(function (t) { if (secondes === t) evenement('lao_fiche_temps', { secondes: t }, 'temps-' + t); });
  }, 5000);

  /* Ajout au panier, routine, avis, bulles vidéo PlayShorts */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-bar-add-to-cart]')) evenement('lao_fiche_ajout_panier', { source: 'barre_fixe' });
    else if (e.target.closest('.lao2-produit [name="add"], .lao2-produit button[type="submit"][id^="ProductSubmitButton"]')) evenement('lao_fiche_ajout_panier', { source: 'bouton_principal' });
    var c = e.target.closest('[data-lao-clic]');
    if (c) {
      var el = c.getAttribute('data-lao-clic');
      if (el === 'routine_complete' || el === 'routine_sur_mesure') evenement('lao_fiche_routine', { element: el });
      if (el === 'trustpilot' || el === 'voir_avis') evenement('lao_fiche_avis_clic', { element: el });
    }
    if (e.target.closest('[class*="playshorts"],[id*="playshorts"],[class*="ps-"],[data-playshorts]')) evenement('lao_fiche_playshorts', {});
    if (e.target.closest('.rb-pdp-cta')) evenement('lao_fiche_routine', { element: 'carte_routine_sur_mesure' });
  }, true);

  /* Replis « Ingrédients et infos », « Conseils d'utilisation »… : un événement à part avec le nom du repli */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DETAILS' && d.open && d.hasAttribute('data-lao-repli')) evenement('lao_fiche_repli', { repli: d.getAttribute('data-lao-repli') });
  }, true);
})();
